module.exports = __webpack_public_path__ + "images/multitankcard_small907e3fb5149b287a8d3abd51b022e1e2.png";